export enum TypeActionArchive {
  RELEASE = 'release',
  RESUBMIT = 'resubmit',
  REDIRECT = 'redirect'
}
